import React from "react";
import {Grid} from "@mui/material";
import SEFilterSelect from "../../../../../../components/SEFilterSelect";
import {sortArrayByProp} from "../../../../../../utils/utils";
import {SEButton} from "../../../../../../components/SEButton";
import {RiFilter3Line, RiFilterOffFill} from "react-icons/ri";
import {SEText} from "../../../../../../components/SEText";
import {useReportsFilter} from "../../../../../../../context/ReportsFilterContext";
import {formatDefaultValueSelect} from "../../../../../../../utils/mask";

export const FiltersConsolidado = ({
  onClearFilters,
  filterOptions,
  isLoading,
  isFetching,
}: {
  onClearFilters: () => void;
  filterOptions: any;
  isLoading: boolean;
  isFetching: boolean;
}) => {
  const { bodyFilters, handleChangeBodyFilter, handleResetBodyFilters } =
    useReportsFilter();
  const handleCleanFilters = () => {
    onClearFilters();
    handleResetBodyFilters();
  };

  return (
    <Grid>
      <Grid
        item
        flexDirection="row"
        display="flex"
        alignItems="center"
        mr={3}
        mb={2}
      >
        <RiFilter3Line />
        <SEText as="p" size={"medium"} font="Mulish" weight="bold">
          Filtros
        </SEText>
      </Grid>
      <Grid
        container
        flexDirection="row"
        display="flex"
        alignItems="center"
        spacing={2}
      >
        <Grid item lg={3}>
          <SEFilterSelect
            defaultOption={isLoading || isFetching ? "Carregando opções..." : "Todas"}
            id={"uf"}
            placeholder={"Selecione uma das opções"}
            label="UF"
            disabled={isLoading || isFetching}
            value={
              filterOptions?.ufs?.filter(
                (uf: any) => uf.id === bodyFilters?.uf?.id
              )?.[0]?.id
            }
            options={sortArrayByProp(filterOptions?.ufs, "sigla")}
            displayField="sigla"
            valueField="id"
            onChange={(value) => handleChangeBodyFilter("uf", { id: value })}
          />
        </Grid>

        <Grid item lg={3}>
          <SEFilterSelect
            defaultOption={isLoading || isFetching ? "Carregando opções..." : "Todos"}
            id={"atendentes"}
            placeholder={"Selecione uma das opções"}
            label="Agente"
            disabled={isLoading || isFetching}
            value={bodyFilters?.atendentes}
            options={filterOptions?.atendentes?.map((i: { nome: string }) => ({
              ...i,
              nome: formatDefaultValueSelect(i.nome),
            }))}
            displayField="nome"
            onChange={(value) => handleChangeBodyFilter("atendentes", value)}
          />
        </Grid>

        <Grid item lg={3}>
          <SEFilterSelect
            defaultOption={isLoading || isFetching ? "Carregando opções..." : "Todos"}
            id={"mes"}
            disabled={isLoading || isFetching}
            placeholder={"Selecione uma das opções"}
            label="Mês"
            value={bodyFilters?.mes}
            options={filterOptions?.meses?.map((i: any) => ( formatDefaultValueSelect(i)))}
            onChange={(value) => handleChangeBodyFilter("mes", value)}
          />
        </Grid>

        <Grid item lg={3}>
          <SEFilterSelect
            defaultOption={isLoading || isFetching ? "Carregando opções..." : "Todos"}
            id={"ano"}
            placeholder={"Selecione uma das opções"}
            label="Ano"
            disabled={isLoading || isFetching}
            value={bodyFilters?.ano}
            options={filterOptions?.anos}
            onChange={(value) =>
              handleChangeBodyFilter("ano", value.toString())
            }
          />
        </Grid>
      </Grid>
      <Grid item lg={12} display="flex" justifyContent="flex-end" mt={3} mb={3}>
        <SEButton
            variant="contained"
            color={'inherit'}
            onClick={handleCleanFilters}
            textStyle={{ fontWeight: "500" }}
        >
          <RiFilterOffFill size={16}  style={{ marginRight: 4 }} />
          Limpar Filtros
        </SEButton>
      </Grid>
    </Grid>
  );
};
